__turbopack_context__.v({
  "documentContainer": "DocumentsTab-module-scss-module__uH3yqq__documentContainer",
  "documentLink": "DocumentsTab-module-scss-module__uH3yqq__documentLink",
  "documentName": "DocumentsTab-module-scss-module__uH3yqq__documentName",
  "iconContainer": "DocumentsTab-module-scss-module__uH3yqq__iconContainer",
});
